import { defaultClient as ApolloClient } from "../../../main";
import { GET_RANK_LIB } from "../../../graphql/ranks/ranksQ";
import {
  ADD_NEW_RANK,
  DELETE_CURRENT_RANK
} from "../../../graphql/ranks/ranksM";

export const actions = {
  allRankLib: async ({ commit }, payload) => {
    // commit("setLoading", true);
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_RANK_LIB,
      variables: payload
    })
      .then(({ data }) => {
        console.log(data);
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setRankLib", data.allRankLib);
        // commit("setLoading", false);
      })
      .catch(err => {
        // commit("setLoading", false);
        console.error(err);
      });
  },

  addNewRank: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: ADD_NEW_RANK,
      variables: payload,
      update: (cache, { data: { rankMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_RANK_LIB
          });
          data.allRankLib.edges.push(rankMerge);

          cache.writeQuery({
            query: GET_RANK_LIB,
            data
          });
        } catch (error) {
          console.error(`Error in addNewRank update hook. Full info: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allRankLib");
      })
      .catch(error => {
        console.error(`Error in addNewRank action. Full info: ${error}`);
      });
  },
  editCurrentRank: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: ADD_NEW_RANK,
      variables: payload,
      update: (cache, { data: { rankMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_RANK_LIB
          });

          const getRank = data.allRankLib.edges.filter(
            rank => +rank.node.rankId === +payload.rankId
          );
          console.log("getRank", getRank);
          const rankIndx = data.allRankLib.edges.indexOf(getRank[0]);
          console.log("rankIndx", rankIndx);
          if (rankIndx !== -1) {
            data.allRankLib.edges[rankIndx] = rankMerge;
            console.log("data", data);
            cache.writeQuery({
              query: GET_RANK_LIB,
              data
            });
            console.log("rankMerge", rankMerge);
            console.log("payload", payload);
          } else {
            console.error(
              "Error in editCurrentRank update hook. No index for current rankMerge"
            );
          }
        } catch (error) {
          console.error(
            `Error in editCurrentRank update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allRankLib");
      })
      .catch(error => {
        console.error(`Error in editCurrentRank action. Full info: ${error}`);
      });
  },
  deleteCurrentRank: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DELETE_CURRENT_RANK,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_RANK_LIB
          });

          data.allRankLib.edges = data.allRankLib.edges.filter(
            rank => +rank.node.rankId !== +payload.rankId
          );
          cache.writeQuery({
            query: GET_RANK_LIB,
            data
          });
        } catch (error) {
          console.error(
            `Error in deleteCurrentRank update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allRankLib");
      })
      .catch(error => {
        console.error(`Error in deleteCurrentRank action. Full info ${error}`);
      });
  }
};
